import { render, staticRenderFns } from "./CustomTemplateSetting.vue?vue&type=template&id=18bcc77d&scoped=true"
import script from "./CustomTemplateSetting.vue?vue&type=script&lang=js"
export * from "./CustomTemplateSetting.vue?vue&type=script&lang=js"
import style0 from "./CustomTemplateSetting.vue?vue&type=style&index=0&id=18bcc77d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bcc77d",
  null
  
)

export default component.exports